// src/store/slices/deitSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { diet } from "../../types/index";

// Initial state for the patient slice
const initialState: diet.DietStateType = {
  dietPlans: {
    isLoading: false,
    data: null,
    errors: null,
  },
  updateStatus: {
    isLoading: false,
    data: null, // will hold response from update API
    errors: null,
  },
};

// Define the patient slice
const deitSlice = createSlice({
  name: "diet",
  initialState,
  reducers: {
    getDietPlansRequest: (
      state: diet.DietStateType,
      action: PayloadAction<any>
    ) => {
      state.dietPlans.isLoading = true;
      state.dietPlans.data = null;
      state.dietPlans.errors = "";
    },
    getDietPlansSuccess: (
      state: diet.DietStateType,
      action: PayloadAction<any>
    ) => {
      state.dietPlans.isLoading = false;
      state.dietPlans.data = action.payload.data;
      state.dietPlans.errors = null;
    },
    getDietPlansError: (
      state: diet.DietStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.dietPlans.isLoading = false;
      state.dietPlans.data = null;
      state.dietPlans.errors = error;
    },

    updateDietPlanStatusRequest: (state, action: PayloadAction<any>) => {
      state.updateStatus.isLoading = true;
      state.updateStatus.errors = null;
    },

    updateDietPlanStatusSuccess: (state, action: PayloadAction<any>) => {
      state.updateStatus.isLoading = false;
      // You can update specific status field here if needed
      state.updateStatus.data = action.payload.data;
      state.updateStatus.errors = null;
    },
    updateDietPlanStatusError: (state, action: PayloadAction<string>) => {
      state.updateStatus.isLoading = false;
      state.updateStatus.errors = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  getDietPlansRequest,
  getDietPlansSuccess,
  getDietPlansError,
  updateDietPlanStatusRequest,
  updateDietPlanStatusSuccess,
  updateDietPlanStatusError,
} = deitSlice.actions;

export default deitSlice.reducer;
